exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "body, html {\n  height: 100%;\n  padding: 0;\n  margin: 0;\n  font-family: Arial;\n  overflow: hidden;\n  font-size: 12px; }\n\n#mapContainer {\n  width: 100%;\n  height: 100%;\n  position: absolute; }\n", "", {"version":3,"sources":["/./src/wgg/src/wgg/styles.scss"],"names":[],"mappings":"AAAA;EACE,aAAY;EACZ,WAAU;EACV,UAAS;EACT,mBAAkB;EAClB,iBAAgB;EAChB,gBAAe,EAChB;;AAED;EACE,YAAW;EACX,aAAY;EACZ,mBAAkB,EACnB","file":"styles.scss","sourcesContent":["body, html {\r\n  height: 100%;\r\n  padding: 0;\r\n  margin: 0;\r\n  font-family: Arial;\r\n  overflow: hidden;\r\n  font-size: 12px;\r\n}\r\n\r\n#mapContainer {\r\n  width: 100%;\r\n  height: 100%;\r\n  position: absolute;\r\n}\r\n"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?sourceMap!./node_modules/sass-loader?sourceMap!./src/wgg/styles.scss
// module id = 4
// module chunks = 0